import React from 'react';

const defaultAvatarUrl = "data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100% 100%' fill='none'%3e%3crect width='100%' height='100%' fill='%23D0D0D0'/%3e%3cg clip-path='url(%23clip0_1143_48193)'%3e%3ccircle cx='49.9996' cy='35.5552' r='12.2222' fill='%239C9C9C'/%3e%3cellipse cx='49.9998' cy='65.5552' rx='21.1111' ry='12.2222' fill='%239C9C9C'/%3e%3c/g%3e%3cdefs%3e%3cclipPath id='clip0_1143_48193'%3e%3cpath d='M0 15C0 6.71573 6.71573 0 15 0H85C93.2843 0 100 6.71573 100 15V85C100 93.2843 93.2843 100 85 100H15C6.71573 100 0 93.2843 0 85V15Z' fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
const Avatar = ({ type = "round", size, imgSrc = null, topOverlayContainer, bottomOverlayContainer, transformContainer, hideBorders }) => {
    const renderTransformContainer = () => {
        if (!transformContainer)
            return null;
        return (React.createElement("div", { className: "mbw-avatar-transform-container-holder" }, transformContainer));
    };
    const renderTopOverlayContainer = () => {
        if (!topOverlayContainer)
            return React.createElement("div", null);
        return (React.createElement("div", { className: "mbw-avatar-top-overlay-container" }, topOverlayContainer));
    };
    const renderBottomOverlayContainer = () => {
        if (!renderBottomOverlayContainer)
            return React.createElement("div", null);
        return (React.createElement("div", { className: "mbw-avatar-bottom-overlay-container" }, bottomOverlayContainer));
    };
    const renderOverlaysContainer = () => {
        if (!topOverlayContainer && !bottomOverlayContainer)
            return null;
        return (React.createElement("div", { className: 'mbw-avatar-overlays-container' },
            renderTopOverlayContainer(),
            renderBottomOverlayContainer()));
    };
    const getAvatarUrl = () => {
        if (!imgSrc)
            return defaultAvatarUrl;
        return imgSrc || defaultAvatarUrl;
    };
    const getImgContainerHolderClassName = () => {
        let className = `mbw-avatar-${type}-img-container-holder`;
        if (size)
            className = `mbw-avatar-${type}-${size}-img-container-holder`;
        if (!hideBorders)
            return className;
        Object.keys(hideBorders).forEach((key) => {
            switch (key) {
                case "leftTop":
                    className = className + " mbw-avatar-hide-left-top-border-radius";
                    break;
                case "rightTop":
                    className = className + " mbw-avatar-hide-right-top-border-radius";
                    break;
                case "rightBottom":
                    className = className + " mbw-avatar-hide-right-bottom-border-radius";
                    break;
                case "leftBottom":
                    className = className + " mbw-avatar-hide-left-bottom-border-radius";
                    break;
            }
        });
        return className;
    };
    const renderAvatar = () => (React.createElement("div", { className: `mbw-avatar-${type}-container`, "data-testid": "mbw-avatar-container" },
        React.createElement("div", { className: getImgContainerHolderClassName() },
            React.createElement("div", { className: "mbw-avatar-img-container" },
                React.createElement("img", { src: getAvatarUrl(), className: "mbw-avatar-image", alt: "" })),
            renderOverlaysContainer()),
        renderTransformContainer()));
    return renderAvatar();
};

export { Avatar as default };
//# sourceMappingURL=avatar.js.map
